const CLIP_ID_SUFFIX = /_([0-9a-f]{8})$/;

/** A dataset name with the delivery clip id suffix removed. */
export function datasetDisplayName(name: string): string {
  return name.replace(CLIP_ID_SUFFIX, "");
}
